import { render } from "./InternalFooter.vue?vue&type=template&id=1376723e&scoped=true"
import script from "./InternalFooter.vue?vue&type=script&lang=js"
export * from "./InternalFooter.vue?vue&type=script&lang=js"

import "./InternalFooter.vue?vue&type=style&index=0&id=1376723e&scoped=true&lang=css"
import "./InternalFooter.vue?vue&type=style&index=1&id=1376723e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1376723e"]])

export default __exports__